import stateOptions from '../options/state';
import countryOptions from '../options/countries';

export default {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Name',
    breed: 'input', 
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  logo: {
    value: '',
    fileName: '',
    error: null,
    name: 'logo',
    placeholder: 'Logo Upload',
    breed: 'file',
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  primary_color: {
    value: '',
    error: null,
    name: 'primary_color',
    placeholder: 'Primary Color',
    breed: 'input',
    touched: false,
    isHalf: true,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  secondary_color: {
    value: '',
    error: null,
    name: 'secondary_color',
    placeholder: 'Secondary Color',
    breed: 'input',
    isHalf: true,
    pullRight: true,
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  address1: {
    value: '',
    error: null,
    name: 'address1',
    placeholder: 'Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  city: {
    value: '',
    error: null,
    name: 'city',
    placeholder: 'City',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  state: {
    value: '',
    error: null,
    name: 'state',
    placeholder: 'State',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: stateOptions,
    displayValue: '',
    isActive: false
  },
  postal_code: {
    value: '',
    error: null,
    name: 'postal_code',
    placeholder: 'Zip',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  country: {
    value: '',
    error: null,
    name: 'country',
    placeholder: 'Country',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: countryOptions,
    displayValue: '',
    isActive: false      
  },
  phone: {
    value: '',
    error: null,
    name: 'phone',
    placeholder: 'Phone',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'phone',
    hasBlurred: false,
    inputType: 'text',
  },
  bi_url: {
    value: '',
    error: null,
    name: 'bi_url',
    placeholder: 'BI Url',
    breed: 'input',
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },

}



/** WEBPACK FOOTER **
 ** ./src/forms/company/create.js
 **/